import React, { useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import { updateUser } from "../../services/Users-services";
import { toast } from "sonner";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import profileImage from "../../assets/images/no-profile-picture.png";
import { callToast } from "../../../src/services/utilityFunctions.js";
import dayjs from "dayjs";
const UpdateUserForm = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const userData = location.state?.userData;

  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    partnerInfo: {
      firstName: userData["FIRST NAME"] == null ? "" : userData["FIRST NAME"],
      lastName: userData["LAST NAME"] == null ? "" : userData["LAST NAME"],

      email: userData["EMAIL"] == null ? "" : userData["EMAIL"],
      userMobile: userData["MOBILE"] == null ? "" : userData["MOBILE"],
    },
    patnerInfo2: {
      description: userData.description == null ? "" : userData.description,
      dob: userData["BIRTH DATE"] == null ? "" : userData["BIRTH DATE"],
      gender: userData.GENDER.code == null ? "" : userData.GENDER.code,

      maritalStatus:
        userData["MARITAL STATUS"].code == null
          ? ""
          : userData["MARITAL STATUS"].code,
    },
    addressInfo: {
      type: userData.type == null ? "" : userData.type,
      country: userData.country == null ? "" : userData.country,
      state: userData.state == null ? "" : userData.state,
      city: userData.city == null ? "" : userData.city,
    },
    addressForm: {
      pinCode: userData.pinCode == null ? "" : userData.pinCode,
      address1: userData.address1 == null ? "" : userData.address1,
      address2: userData.address2 == null ? "" : userData.address2,
      landmark: userData.landmark == null ? "" : userData.landmark,
    },
  });

  console.log("userData", userData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fieldErros, setFiledErrors] = useState([]);
  const handleChange = (step, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [step]: { ...prev[step], [field]: value },
    }));
  };

  const validateFields = () => {
    const currentForm = Object.entries(formData[getCurrentStepKey()]);
    const newErrors = {};
    currentForm.forEach(([key, value]) => {
      if (key == "image") {
        if (value == "") newErrors[key] = `${key} is required`;
        return;
      }
      if (!value.trim()) newErrors[key] = `${key} is required`;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getCurrentStepKey = () => {
    switch (currentStep) {
      case 1:
        return "partnerInfo";
      case 2:
        return "patnerInfo2";
      case 3:
        return "addressInfo";
      case 4:
        return "addressForm";

      default:
        return "partnerInfo";
    }
  };

  const handleNext = async () => {
    if (validateFields()) {
      if (currentStep < 3) {
        setCurrentStep(currentStep + 1);
      } else {
        var data = {};
        Object.entries(formData).map(([key, value]) => {
          Object.entries(value).map(([key1, value1]) => {
            data[key1] = value1;
          });
        });
        setLoading(true);

        var res = await updateUser(data, userData["_ID"]);
        if (res.status == "fail") {
          if (res.data) {
            var newErrors = {};

            Object.entries(res.data.fieldErrors).map(([key, value]) => {
              var message = "";
              value.map((msg) => {
                message += msg.message + "\n";
              });
              newErrors[key] = message;
            });

            setErrors(newErrors);
            setLoading(false);
            setCurrentStep(1);

            res.data.failures.map((item) => {
              const myButton = document.getElementById("myToastButton");
              callToast("error", "FAILURE", item.message, myButton);
            });
          } else {
          }
        } else {
          const myButton = document.getElementById("myToastButton");
          callToast(
            "success",
            "Updated",
            "User updated successfully",
            myButton
          );

          setTimeout(() => {
            setLoading(false);
            navigate(-1);
          }, 500);
          // navigate("/");
        }
      }
    }
  };

  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*";
  const handleImageInput = () => {
    console.log("called");
    input.onchange = (e) => {
      var file = e.target.files[0];
      if (file) {
        handleChange("patnerInfo2", "image", file);
      }
    };
    input.click();
  };
  const formatDate = (dateString) => {
    const date = dayjs(dateString);
    return date.isValid() ? date.format("YYYY-MM-DD") : "";
  };

  return (
    <>
      <section className="login-content">
        <div
          id="myToastButton"
          class="pixel-corners"
          style={{ display: "block" }}
        ></div>
        <div className="vh-100 d-flex align-items-center justify-content-center bg-light ">
          <div
            className="position-relative bg-white shadow-sm rounded m-5"
            style={{ width: "70vw" }}
          >
            <div
              className="position-absolute top-10 start-20 bg-primary"
              style={{
                left: "5%",
                top: "-10%",
                width: "12%",
                height: "120%",
                backgroundColor: "blue",
              }}
            ></div>

            <div className="d-flex" style={{ marginLeft: "18%" }}>
              <div className="w-100 p-5">
                <div className="d-flex justify-content-end">
                  <h4 className="text-primary">Update User</h4>
                </div>
                <h3 className="mb-4">
                  {currentStep === 1
                    ? "Partner Info"
                    : currentStep === 2
                    ? "Address Info"
                    : currentStep === 3
                    ? "Address Form"
                    : "Address Form"}
                </h3>
                <form>
                  {currentStep === 1 ? (
                    <>
                      <div className="mb-3">
                        <div className="form-row ">
                          <div class="col">
                            <label className="form-label">First Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter First Name"
                              value={formData[getCurrentStepKey()].firstName}
                              onChange={(e) =>
                                handleChange(
                                  getCurrentStepKey(),
                                  "firstName",
                                  e.target.value
                                )
                              }
                            />
                            {errors.firstName && (
                              <small className="text-danger">
                                {errors.firstName}
                              </small>
                            )}
                          </div>
                          <div class="col">
                            <label className="form-label">Last Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter last Name"
                              value={formData[getCurrentStepKey()].lastName}
                              onChange={(e) =>
                                handleChange(
                                  getCurrentStepKey(),
                                  "lastName",
                                  e.target.value
                                )
                              }
                            />
                            {errors.lastName && (
                              <small className="text-danger">
                                {errors.lastName}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          value={formData[getCurrentStepKey()].email}
                          onChange={(e) =>
                            handleChange(
                              getCurrentStepKey(),
                              "email",
                              e.target.value
                            )
                          }
                        />
                        {errors.email && (
                          <small className="text-danger">{errors.email}</small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">userMobile No.</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter userMobile Number"
                          value={formData[getCurrentStepKey()].userMobile}
                          onChange={(e) =>
                            handleChange(
                              getCurrentStepKey(),
                              "userMobile",
                              e.target.value
                            )
                          }
                        />
                        {errors.userMobile && (
                          <small className="text-danger">
                            {errors.userMobile}
                          </small>
                        )}
                      </div>
                    </>
                  ) : currentStep === 2 ? (
                    <>
                      {" "}
                      <div className="row">
                        {/* <div className="col-md-6 mb-3  justify-content-center">
                          <div class="col  ms-3 mb-2">
                            <div
                              className="rounded-circle overflow-hidden"
                              style={{
                                width: "150px",
                                height: "150px",
                                border: "2px solid #ddd",
                              }}
                            >
                              <img
                                src={
                                  formData.patnerInfo2.image !== ""
                                    ? URL.createObjectURL(
                                        formData.patnerInfo2.image
                                      )
                                    : profileImage
                                }
                                alt="Profile"
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                              />
                            </div>
                            {errors.image && (
                              <small className="text-danger">
                                {errors.image}
                              </small>
                            )}
                          </div>
                          <div className="col  ms-5">
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={handleImageInput}
                            >
                              Add
                            </button>
                          </div>
                        </div> */}
                        <div className="col-md-6 mb-3">
                          <div class="col">
                            <label className="form-label">dob</label>
                          </div>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              defaultValue={dayjs(formData.patnerInfo2.dob)}
                              onChange={(e) => {
                                handleChange(
                                  "patnerInfo2",
                                  "dob",
                                  e.format("DD/MM/YYYY").toString()
                                );
                              }}
                            />
                          </LocalizationProvider>

                          <div className="col">
                            {errors.dob && (
                              <small className="text-danger">
                                {errors.dob}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Description"
                          value={formData[getCurrentStepKey()].description}
                          onChange={(e) =>
                            handleChange(
                              getCurrentStepKey(),
                              "description",
                              e.target.value
                            )
                          }
                        />
                        {errors.description && (
                          <small className="text-danger">
                            {errors.description}
                          </small>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-6 mb-3 mt-3 bg-">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">
                              Maritail Status{" "}
                            </label>
                          </div>
                          <div className="form-check form-check-inline ms-4">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio1"
                              checked={
                                formData.patnerInfo2.maritalStatus == "MARRIED"
                              }
                              onChange={(e) =>
                                handleChange(
                                  "patnerInfo2",
                                  "maritalStatus",
                                  "MARRIED"
                                )
                              }
                              value="married"
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio1"
                            >
                              married
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio2"
                              checked={
                                formData.patnerInfo2.maritalStatus ===
                                "UNMARRIED"
                              }
                              onChange={(e) =>
                                handleChange(
                                  "patnerInfo2",
                                  "maritalStatus",
                                  "UNMARRIED"
                                )
                              }
                              value="unmarried"
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio2"
                            >
                              Un-married
                            </label>
                            {}
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio2"
                              checked={
                                formData.patnerInfo2.maritalStatus === "WIDOW"
                              }
                              onChange={(e) =>
                                handleChange(
                                  "patnerInfo2",
                                  "maritalStatus",
                                  "WIDOW"
                                )
                              }
                              value="unmarried"
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio2"
                            >
                              Widow
                            </label>
                            {}
                          </div>
                          {errors.maritalStatus && (
                            <div class="col">
                              <small className="text-danger">
                                {errors.maritalStatus}
                              </small>
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3 mt-3 bg-">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Gender </label>
                          </div>
                          <div className="form-check form-check-inline ms-4">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions2"
                              id="inlineRadio3"
                              checked={formData.patnerInfo2.gender === "MALE"}
                              onChange={(e) =>
                                handleChange("patnerInfo2", "gender", "MALE")
                              }
                              value="male"
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio3"
                            >
                              Male
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions2"
                              id="inlineRadio4"
                              checked={formData.patnerInfo2.gender === "FEMALE"}
                              onChange={(e) =>
                                handleChange("patnerInfo2", "gender", "FEMALE")
                              }
                              value="female"
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio4"
                            >
                              Female
                            </label>
                            {}
                          </div>
                          <div className="form-check form-check-inline ms-4">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions2"
                              id="inlineRadio3"
                              checked={
                                formData.patnerInfo2.gender === "TRANSGENDER"
                              }
                              onChange={(e) =>
                                handleChange(
                                  "patnerInfo2",
                                  "gender",
                                  "TRANSGENDER"
                                )
                              }
                              value="TRANSGENDER"
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio3"
                            >
                              Transgender
                            </label>
                          </div>
                          {errors.gender && (
                            <div class="col">
                              <small className="text-danger">
                                {errors.gender}
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : currentStep === 3 ? (
                    <>
                      <div className="mb-3">
                        <label className="form-label">Type</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Type"
                          value={formData.addressInfo.type}
                          onChange={(e) =>
                            handleChange("addressInfo", "type", e.target.value)
                          }
                        />
                        {errors.type && (
                          <small className="text-danger">{errors.type}</small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Country"
                          value={formData.addressInfo.country}
                          onChange={(e) =>
                            handleChange(
                              "addressInfo",
                              "country",
                              e.target.value
                            )
                          }
                        />
                        {errors.country && (
                          <small className="text-danger">
                            {errors.country}
                          </small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter State"
                          value={formData.addressInfo.state}
                          onChange={(e) =>
                            handleChange("addressInfo", "state", e.target.value)
                          }
                        />
                        {errors.state && (
                          <small className="text-danger">{errors.state}</small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter City"
                          value={formData.addressInfo.city}
                          onChange={(e) =>
                            handleChange("addressInfo", "city", e.target.value)
                          }
                        />
                        {errors.city && (
                          <small className="text-danger">{errors.city}</small>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="mb-3">
                        <label className="form-label">Pin Code</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Pin Code"
                          value={formData.addressForm.pinCode}
                          onChange={(e) =>
                            handleChange(
                              "addressForm",
                              "pinCode",
                              e.target.value
                            )
                          }
                        />
                        {errors.pinCode && (
                          <small className="text-danger">
                            {errors.pinCode}
                          </small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Address Line 1</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address Line 1"
                          value={formData.addressForm.address1}
                          onChange={(e) =>
                            handleChange(
                              "addressForm",
                              "address1",
                              e.target.value
                            )
                          }
                        />
                        {errors.address1 && (
                          <small className="text-danger">
                            {errors.address1}
                          </small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Address Line 2</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address Line 2"
                          value={formData.addressForm.address2}
                          onChange={(e) =>
                            handleChange(
                              "addressForm",
                              "address2",
                              e.target.value
                            )
                          }
                        />
                        {errors.address2 && (
                          <small className="text-danger">
                            {errors.address2}
                          </small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Landmark</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Landmark"
                          value={formData.addressForm.landmark}
                          onChange={(e) =>
                            handleChange(
                              "addressForm",
                              "landmark",
                              e.target.value
                            )
                          }
                        />
                        {errors.landmark && (
                          <small className="text-danger">
                            {errors.landmark}
                          </small>
                        )}
                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-between mt-4">
                    {currentStep > 1 && (
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleBack}
                        disabled={loading}
                      >
                        Back
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleNext}
                      disabled={loading}
                    >
                      {loading ? (
                        <div class="spinner-border text-light" role="status">
                   
                        </div>
                      ) : currentStep < 4 ? (
                        "Next"
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateUserForm;
